import { render, staticRenderFns } from "./IconMap.vue?vue&type=template&id=0f81dbc4"
import script from "./IconMap.vue?vue&type=script&lang=js"
export * from "./IconMap.vue?vue&type=script&lang=js"
import style0 from "./IconMap.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports